import { Grid, Box, Typography, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Autocomplete } from 'components/Autocomplete/Autocomplete'
import Input from 'components/Input/Input'
import { getIn, useFormikContext } from 'formik'
import { NutrientDetail } from 'types/model/product'
import { t } from 'i18next'

export const OptionalNutrients = ({
  nutrient,
  index,
  i,
  measurementCodes,
  nutrientTypeCodes,
  nutrientDetails,
}: {
  nutrient: NutrientDetail
  index: number
  i: number
  measurementCodes: { label: string; value: string }[]
  nutrientTypeCodes: { label: string; value: string }[]
  nutrientDetails: NutrientDetail[]
}) => {
  const { setFieldValue, errors } = useFormikContext()
  const nutrientName = nutrientTypeCodes.find(
    (code: { label: string; value: string }) =>
      code.value === nutrient.nutrientTypeCode
  )?.label
  const measurementCode = measurementCodes.find(
    (code) => code.value === nutrient.quantityUnit
  )
  const formatFieldName = (name: string) => {
    return `nutrientHeaders.${index}.nutrientDetails.${i}.${name}`
  }
  const formatErrorMessage = (name: string) => {
    const errorPath = `nutrientHeaders[${index}].nutrientDetails.${i}.${name}`
    return getIn(errors, errorPath)
  }
  const handleDelete = (nutrientId: string) => {
    const newOptionalNutrients = nutrientDetails.filter(
      (tempNutrient) => tempNutrient.id !== nutrientId
    )
    setFieldValue(`nutrientHeaders.${index}.nutrientDetails`, [
      ...newOptionalNutrients,
    ])
  }
  return (
    <>
      <Grid item xs={3.5}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ fontSize: '18px', textTransform: 'capitalize' }}>
            {nutrientName}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Input
          errorMessage={formatErrorMessage('quantity')}
          label=''
          name={formatFieldName('quantity')}
          type='text'
          variant='filled'
        />
      </Grid>
      <Grid item xs={3}>
        <Autocomplete
          options={measurementCodes ?? []}
          onChange={(newUnit) => {
            setFieldValue(formatFieldName('quantityUnit'), newUnit?.value)
          }}
          onClear={() => setFieldValue(formatFieldName('quantityUnit'), null)}
          value={measurementCode || null}
          name={nutrient.nutrientTypeCode}
          label=''
        />
      </Grid>
      <Grid item xs={2}>
        <Input
          errorMessage={formatErrorMessage('dailyValueIntakePercent')}
          label=''
          name={formatFieldName('dailyValueIntakePercent')}
          type='text'
          variant='filled'
        />
      </Grid>
      <Grid item xs={1}>
        <IconButton
          aria-label={t('deleteNutrient')}
          onClick={() => handleDelete(nutrient.id)}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </>
  )
}
